import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=65f1c5c8&"
import script from "./ChatBot.vue?vue&type=script&lang=ts&"
export * from "./ChatBot.vue?vue&type=script&lang=ts&"
import style0 from "../../assets/css/components/chat-bot.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports